// extracted by mini-css-extract-plugin
export default {"turboIcon":"wZ2pnZoc0qnkDrInIozF","turboIconImage":"Ys2k1lm3GvBd7fAUvZDA","turboIconText":"WLh1m7RUWLzRdo3v1ohK"};